import { FCKameleonBlock } from "../typings/tetris-blocks";
import { LayoutPropsOptions } from "../helpers/prop-types-helper";

export type KameleonElement = {
  component: FCKameleonBlock;
  blockInfo: object;
  defaultProps: {
    layoutProps: object;
    contentProps: object;
  };
  layoutOptions: LayoutPropsOptions;
};

export function isKameleonElement(object: any): object is KameleonElement {
  return (
    "component" in object && "blockInfo" in object && "defaultProps" in object
  );
}
